import swal from "sweetalert";

export const ErrorSuccessHandler = async (msg, type) => {
  await swal({ title: msg, icon: type, timer: 1000 });
};
